import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Video, ArrowRight } from 'lucide-react';
const SLIDES = [{
  id: 1,
  bgImage: 'https://cdn.magicpatterns.com/uploads/oBXETRa9M5FVcBfWYLcQGV/ChatGPT_Image_Mar_11,_2026,_04_41_54_PM.png',
  bgPosition: 'center',
  headlinePart1: 'Esther Mensah Counselling & Psychotherapy, ',
  headlinePart2: 'London, Ontario.',
  subheadline: 'Supporting individuals, couples, and families through PTSD, trauma, grief, and relationship or parenting struggles with care, understanding, and guidance toward healing and connection.'
}, {
  id: 2,
  bgImage: 'https://cdn.magicpatterns.com/uploads/oZmsr2iTj7fpJtxHL7s1zL/acd2118d-a765-46c7-b1b2-a4ac3f5a6c90.png',
  bgPosition: 'top',
  headlinePart1: 'Culturally Sensitive, ',
  headlinePart2: 'Evidence-Based Therapy.',
  subheadline: 'EMDR, CBT, and trauma-informed care rooted in compassion and understanding.'
}, {
  id: 3,
  bgImage: 'https://cdn.magicpatterns.com/uploads/x2k8PB5oyDM5ZkSFWXqAWC/Mixed-family-with-teen-girls-at-park-sq-frame.webp',
  bgPosition: 'center',
  headlinePart1: 'Your Journey to Wellness ',
  headlinePart2: 'Starts Here.',
  subheadline: 'No referral required. Book a free 15-minute consultation today.'
}];
export function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % SLIDES.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);
  return <section id="home" className="relative h-[480px] md:h-[520px] flex items-center overflow-hidden" data-id="element-405">
      <div className="absolute inset-0 bg-charcoal z-0" data-id="element-406" />

      {/* Background images crossfade using CSS transitions */}
      {SLIDES.map((slide, index) => <div key={slide.id} className={`absolute inset-0 z-[1] transition-opacity duration-1000 ease-in-out ${currentSlide === index ? 'opacity-100' : 'opacity-0'}`} data-id="element-407">
          <div className="absolute inset-0 bg-cover" style={{
        backgroundImage: `url(${slide.bgImage})`,
        backgroundPosition: slide.bgPosition || 'center'
      }} data-id="element-408" />
          <div className="absolute inset-0 bg-gradient-to-r from-charcoal/90 via-charcoal/70 to-charcoal/40" data-id="element-409" />
        </div>)}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full py-8 md:py-12" data-id="element-410">
        <div className="max-w-2xl text-center lg:text-left" data-id="element-411">
          <div data-id="element-412">
            <span className="inline-block py-1 px-3 rounded-full bg-white/15 backdrop-blur-sm text-white font-bold text-xs mb-4 tracking-wide uppercase" data-id="element-413">
              Registered Social Worker & Psychotherapist
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] mb-4 text-balance text-white" data-id="element-414">
              {SLIDES[currentSlide].headlinePart1}
              <span className="text-gold" data-id="element-415">
                {SLIDES[currentSlide].headlinePart2}
              </span>
            </h1>

            <p className="text-base text-white/85 mb-6 max-w-xl mx-auto lg:mx-0 leading-relaxed font-medium" data-id="element-416">
              {SLIDES[currentSlide].subheadline}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start mb-6" data-id="element-417">
            <Link to="/booking" className="inline-flex items-center justify-center bg-olive text-white px-8 py-4 md:px-10 md:py-4 rounded-full font-bold text-base transition-all shadow-[0_0_20px_rgba(89,111,89,0.5)] hover:shadow-[0_0_30px_rgba(89,111,89,0.7)] hover:bg-olive/90 min-h-[52px] tracking-wide ring-2 ring-white/30" data-id="element-418">
              Book An Appointment
              <ArrowRight size={18} className="ml-2" data-id="element-419" />
            </Link>
            <Link to="/booking" className="inline-flex items-center justify-center bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white border border-white/30 px-6 py-3 md:px-8 md:py-3.5 rounded-full font-bold text-sm transition-all min-h-[48px] tracking-wide" data-id="element-420">
              Book a Free Consult
            </Link>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 text-sm font-medium text-white/70" data-id="element-421">
            <div className="flex items-center gap-1.5" data-id="element-422">
              <MapPin size={14} data-id="element-423" />
              <span data-id="element-424">In-Person · London, Ontario</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-425">
              <Video size={14} data-id="element-426" />
              <span data-id="element-427">Virtual · Across Ontario</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-0 right-0 flex justify-center gap-2.5 z-20" data-id="element-428">
        {SLIDES.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${currentSlide === index ? 'bg-gold scale-125' : 'bg-white/30 hover:bg-white/50'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-429" />)}
      </div>
    </section>;
}